import Vue from 'vue'
import App from './App.vue'
import router from './router/routerHook.js'

import store from './store/store'
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';//默认主题
// import './assets/css/theme/index.css';       // 浅绿色主题
import './assets/css/icon.css';//图标
import api from './api/api.js'
import apiV1_1 from './api/v1.1/api.js'
import ysApi from './api/ysProductApi.js'
import ysApiV1_1 from './api/v1.1/ysProductApi.js'
import publicFunction from './api/public.js'
import md5 from 'js-md5';
// 刷新丢失
// import routerPermission from "./router/permission";
// const permission=routerPermission(store.state.store.logininfo.menuList)
// if(permission&&permission.length>0){
// 	permission.forEach((route)=>{
// 		router.addRoute((route))
// 	})
// }

Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.prototype.$api = api
Vue.prototype.$apiV1_1 = apiV1_1
Vue.prototype.$ysApi =ysApi
Vue.prototype.$ysApiV1_1 =ysApiV1_1
Vue.prototype.$publicFunction = publicFunction
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
Vue.prototype.$store = store



Vue.directive('dialogDrag', {})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')